import React from 'react';

import DiagnoseImage from 'assets/images/pages/homepage/diagnose.png';
import DesignImage from 'assets/images/pages/homepage/design.png';
import EarnImage from 'assets/images/pages/homepage/earn.png';
import ShowcaseImage from 'assets/images/pages/homepage/showcase.png';
import BuildImage from 'assets/images/pages/homepage/build.png';
import ApplyImage from 'assets/images/pages/homepage/apply.png';

import Student1Image from 'assets/images/pages/homepage/student-1.png';
import Student2Image from 'assets/images/pages/homepage/student-2.png';
import Student3Image from 'assets/images/pages/homepage/student-3.png';
import Student4Image from 'assets/images/pages/homepage/student-4.png';
import Student5Image from 'assets/images/pages/homepage/student-5.png';
import Student6Image from 'assets/images/pages/homepage/student-6.png';

import Job1Image from 'assets/images/pages/homepage/job-1.png';
import Job2Image from 'assets/images/pages/homepage/job-2.png';


import classes from './RoadMap.module.scss';
import LinkButton from '@core/components/linkbutton/LinkButton';

const RoadMap = ({ type, position }) => {
    const roadmapData = {
        students: [
            {
                title: "Clarify Your Career North Star",
                description: "Begin with a one-to-one career consultation to explore your interests and define a clear pharma goal. Revisit this goal to track measurable progress.",
                image: Student1Image.src
            },
            {
                title: "Map Role Requirements & Resources",
                description: "Explore target roles by reviewing competencies, requirements, and employer expectations. Build a resource list, then reconnect with your coach to confirm alignment.",
                image: Student2Image.src
            },
            {
                title: "Sprint Through Skill-Building",
                description: "Follow a targeted course sprint in GMP, safety and data skills. After each module, assess understanding with quizzes and share results with your coach, who suggests next courses or remediation.",
                image: Student3Image.src
            },
            {
                title: "Craft & Polish Your Resume",
                description: "Export your verified certificates into an AI-assisted resume builder that optimizes keywords for applicant-tracking systems. Review the draft with your coach, until the document fully echoes employer language.",
                image: Student4Image.src
            },
            {
                title: "Rehearse & Refine Interviews",
                description: "Practice behavioral and technical questions in simulated interviews, receiving real-time AI and coach feedback on clarity, tone and content.",
                image: Student5Image.src
            },
            {
                title: "Apply, Debrief, Iterate",
                description: "Apply for internships or junior roles and capture recruiter feedback. Re-enter coaching to analyze gaps, update learning priorities and restart the course-skill-feedback cycle, steadily compounding competence and confidence.",
                image: Student6Image.src
            }
        ],
        job_seekers: [
            {
                title: "Diagnose Your Gaps",
                description: "Begin with a pharma career-coach audit that contrasts your experience and CV against current industry benchmarks, generating a personalized gap list you’ll return to after each later checkpoint.",
                image: Job1Image.src
            },
            {
                title: "Select a Target Path",
                description: "Use data-driven career-path tools to map competencies from hundreds of pharmaceutical job descriptions, then confirm the focus role with your coach before proceeding.",
                image: Job2Image.src
            },
            {
                title: "Sprint Through Skill-Building",
                description: "Complete GMP-centric micro-courses benchmarked against 800+ job descriptions; pass quizzes, earn certificates and loop back to diagnose your gaps for a fresh gap analysis.",
                image: Student3Image.src
            },
            {
                title: "Elevate Your Résumé",
                description: "Import new certificates into an ATS-optimized resume builder and fine-tune keywords with your coach, whenever fresh credentials are added.",
                image: Student4Image.src
            },
            {
                title: "Rehearse & Refine Interviews",
                description: "Run mock interviews followed by coach debriefs; if feedback exposes knowledge gaps, jump back to your coach, to update your plan.",
                image: Student5Image.src
            },
            {
                title: "Apply, Debrief, Iterate",
                description: "Submit targeted applications, capture recruiter feedback and reconvene with your coach to adjust strategy—then restart the cycle until you secure the desired role.",
                image: Student6Image.src
            }
        ],
        professionals: [
            {
                title: "Diagnose Your Expertise Gaps",
                description: "Begin with a pharma career-coach audit that contrasts your experience and CV against current industry benchmarks, generating a personalized gap list you’ll return to after each later checkpoint.",
                image: DiagnoseImage.src
            },
            {
                title: "Design a Strategic Learning Plan",
                description: "Use data-driven career-path tools to map competencies from hundreds of pharmaceutical job descriptions, then confirm the focus role with your coach before proceeding.",
                image: DesignImage.src
            },
            {
                title: "Earn High-Value Technical Credentials",
                description: "Complete GMP-centric micro-courses benchmarked against 800+ job descriptions; pass quizzes, earn certificates and loop back to diagnose your gaps for a fresh gap analysis.",
                image: EarnImage.src
            },
            {
                title: "Build Leadership & Soft Skills",
                description: "Import new certificates into an ATS-optimized resume builder and fine-tune keywords with your coach, whenever fresh credentials are added.",
                image: BuildImage.src
            },
            {
                title: "Showcase Impact & Negotiate Value",
                description: "Run mock interviews followed by coach debriefs; if feedback exposes knowledge gaps, jump back to your coach, to update your plan.",
                image: ShowcaseImage.src
            },
            {
                title: "Apply, Debrief, Iterate",
                description: "Submit targeted applications, capture recruiter feedback and reconvene with your coach to adjust strategy—then restart the cycle until you secure the desired role.",
                image: ApplyImage.src
            }
        ]
    };

    return (
        <>
            <div className={`${classes.wrapper} ${classes[type]}`}>
                <div className={classes.item}>
                    <img src={roadmapData[type][0].image} alt="Diagnose" />
                    <h3>{roadmapData[type][0].title}</h3>
                    <p>
                        {roadmapData[type][0].description}
                    </p>
                </div>
                <div className={classes.item}>
                    <img src={roadmapData[type][1].image} alt="Design" />
                    <h3>{roadmapData[type][1].title}</h3>
                    <p>
                        {roadmapData[type][1].description}
                    </p>
                </div>
                <div className={classes.item}>
                    <img src={roadmapData[type][2].image} alt="Earn" />
                    <h3>{roadmapData[type][2].title}</h3>
                    <p>
                        {roadmapData[type][2].description}
                    </p>
                </div>
                <div className={classes.item}>
                    <img src={roadmapData[type][3].image} alt="Build" />
                    <h3>{roadmapData[type][3].title}</h3>
                    <p>
                        {roadmapData[type][3].description}
                    </p>
                </div>
                <div className={classes.item}>
                    <img src={roadmapData[type][4].image} alt="Diagnose" />
                    <h3>{roadmapData[type][4].title}</h3>
                    <p>
                        {roadmapData[type][4].description}
                    </p>
                </div>
            </div>
            <div className={`${classes['roadmap-footer']}  ${classes[type]}`}>
                <div className={classes.item}>
                    <img src={roadmapData[type][5].image} alt="Apply" />
                    <div>
                        <h3>{roadmapData[type][5].title}</h3>
                        <p>{roadmapData[type][5].description}</p>
                    </div>
                </div>
                <LinkButton kind='primary-color' to={position === 'up' ?
                    '/plans?utm_source=abtest&utm_medium=homepage&utm_campaign=audience-up&utm_id=abtest-home-up-001&utm_content=plans'
                    :
                    '/plans?utm_source=abtest&utm_medium=homepage&utm_campaign=audience-down&utm_id=abtest-home-down-002&utm_content=plans'}>
                    See How Pharmuni Helps You
                </LinkButton>
            </div>
        </>
    );
};

export default RoadMap;